module.exports = __webpack_public_path__ + "static/img/180919-feature-dr-chua.1c6c8aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/180919-feature-dr-chua.jpg
// module id = 9OX4
// module chunks = 0